import { gql } from "@outschool/ui-apollo";

export const fundingProgramPropertiesQuery = gql`
  query FundingProgramProperties {
    fundingProgramProperties {
      abbreviation
      fundingState
      isClassWallet
      institution
      programName
      programNameLong
      programNameAbbr
      programUrl
      programEndDate
      waitPeriodDays
      landingPagePath
    }
  }
`;
